// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Space, Text } from '@mantine/core';
import { FC, useContext } from 'react';
import { useElementSize } from '@mantine/hooks';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import { Language } from '../../../Service/DocumentT';
import DocumentLanguageS from '../../../Service/DocumentLanguageS';

const PositionHeader: FC<{
  documentVersion: boolean;
  desktopVersion: boolean;
  showDiscount: boolean;
  currencySymbol?: string;
  isPartialInvouce?: boolean;
  language?: Language | null;
}> = ({
  documentVersion,
  desktopVersion,
  showDiscount = true,
  currencySymbol = '€',
  isPartialInvouce = false,
  language = 'german',
}) => {
  const { profile } = useContext(ProfileContext);
  const { ref, width } = useElementSize();
  const t = (id: string) => DocumentLanguageS.translate(language, id);

  return (
    <Group
      ref={ref}
      spacing="xs"
      p={6}
      sx={(theme) => ({
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.silver[9],
        borderRadius: 6,
        color: 'white',
        fontSize: 12,
      })}
    >
      {desktopVersion ? (
        <>
          {documentVersion && <Space w={35} />}
          <Text ml={documentVersion ? 0 : 'xs'} sx={{ width: width - (isPartialInvouce ? 500 : 630) }}>
            {t('document.position.product_service')}
          </Text>
          <Text sx={{ width: 50 }}>{t('document.position.quantity')}</Text>
          <Text sx={{ width: 60 }}>{t('document.position.unit')}</Text>
          <Text sx={{ width: 70 }}>{`${t('document.position.price')} (${currencySymbol})`}</Text>
          {profile && !profile.smallScaleBusiness && <Text sx={{ width: 60 }}>{t('document.position.tax')} (%)</Text>}
          {showDiscount && <Text sx={{ width: 130 }}>{t('document.position.discount')}</Text>}
          <Text align="center" sx={{ width: 100 }}>
            {t('document.position.total')}
          </Text>
        </>
      ) : (
        <Text ml="xs">{t('document.position.positions')}</Text>
      )}
    </Group>
  );
};

export default PositionHeader;
